<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col class="col-values">
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="
            $router.push(
              `/cidade/${municipioId}/agenteTerritorial/${tabType}/0`
            )
          "
        >
          Adicionar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="values"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template slot="no-data">
            <span> Nenhum Ator </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              outlined
              color="warning"
              class="mr-3"
              @click="
                $router.push(
                  `/cidade/${municipioId}/agenteTerritorial/${tabType}/${item.idAtor}`
                )
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <modalDelete :payload="item" @onDelete="load()">
              <template v-slot:title> Deletar Ator </template>
            </modalDelete>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { atoresApi } from "@/apis";
import modalDelete from "./modalDelete";

export default {
  components: {
    modalDelete,
  },
  data() {
    return {
      municipioId: this.$route.params.id,
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Telefone", value: "telefone" },
        { text: "E-mail", value: "email" },
        { text: "Cargo/Função", value: "cargoFuncao" },
        { text: "Instituição", value: "instituicao" },
        { text: "Grau de Influência", value: "grauInfluencia" },
        { text: "Grau de Impacto", value: "grauImpacto" },
        {
          text: "Ações",
          value: "actions",
        },
      ],
      tabType: this.$route.params.tab,
      values: [],
      search: "",
    };
  },

  methods: {
    ...mapActions(["setLoading", "setConfig"]),
    load() {
      this.setLoading(true);
      atoresApi
        .getByMunicipio(this.municipioId)
        .then(({ data }) => {
          this.values = data;
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
<style scoped>
.col-values {
  display: flex;
  justify-content: flex-end;
}
</style>
